// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"57753900","150":"ca7f213c","261":"11149871","549":"a3c4dff1","670":"e199cfcc"}[chunkId] + ".chunk.js";
};